import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const trialIdentificationStatusService = {
  basePath: organizationId =>
    `${clinicalApiPath}/organizations/${organizationId}/trialIdentification`,

  createTrialIdentificiationStatus(orgId, status) {
    return viperApi.post(`${this.basePath(orgId)}/${status.trialIdentificationId}/status`, status)
  },

  getTrialIdentificationStatusDetails(orgId) {
    return viperApi.get(`${this.basePath(orgId)}/status/details`)
  }
}
